export default {
  lang: {
    confirm: {
      title: 'هل أكدت أنك تريد حذفها ؟ لن يتم استعادتها بعد الحذف',
      okText: 'حذف',
      cancelText: 'إلغاء',
    },
  },
};
